import { Component } from '@angular/core';
import { LiveClassCountdownTimerService } from '../../../../../../home/live-class-section/services/live-class-countdown-timer.service';
import { OeAppService } from '../../../../../../shared/oe-app.service';
import { LiveClassWithCountdownTimerPlusMinutesComponent } from '../../../../live-class-with-countdown-timer/live-class-with-countdown-timer-plus-minutes.component';

@Component({
  selector: 'lp2-group-class-state-none',
  template: `
    <lp2-live-class-state-view-title [labelKey]="labelKeyForGroup"></lp2-live-class-state-view-title>
    <div class="pt-2 pb-3 d-flex flex-column align-items-center">
      <lp2-live-class-state-view-timer
        theme="light"
        [minutes]="minutesForGroup"
        [seconds]="seconds"
      ></lp2-live-class-state-view-timer>
      <span class="mt-2">{{ 'oeapp.studybundle.gc.reserveSpotInstruction' | translate }}</span>
      <ng-content></ng-content>
    </div>
  `,
})
export class GroupClassStateNoneComponent extends LiveClassWithCountdownTimerPlusMinutesComponent {
  private timerService: LiveClassCountdownTimerService;

  constructor(liveClassCountdownTimerService: LiveClassCountdownTimerService, private oeAppService: OeAppService) {
    super(liveClassCountdownTimerService);
    this.timerService = liveClassCountdownTimerService;
    this.signUpConfigValue = this.oeAppService.getData('liveClassStudentSignUpStart');
  }

  /* 
    Override parent's minutesForGroup to fix the +7min jump for signupEnabled=false classes.
    The timer service subtracts signUpStart or signUpEnd from msToClassBegin depending on the phase.
    signupEnabled=true: always uses signUpStart here (tile switches to CAN_SIGN_UP component before phase changes).
    signupEnabled=false: stays in NONE, so we read currentSignUpOffset to match whatever the service subtracted.
  */
  public get minutesForGroup() {
    const offset = this.liveClass && !this.liveClass.signupEnabled
      ? this.timerService.currentSignUpOffset
      : this.signUpConfigValue;
    return (Number(this.minutes) + Math.trunc(offset / 1000 / 60)).toString();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/group-class/group-class-tile/group-class-tile-states/states/group-class-state-none.component.ts